/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import ButtonGroup from '@zg-rentals/multibrand-ui/lib/ButtonGroup';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import { withCookies } from 'react-cookie';

class BrandSwitcher extends React.Component {
  updateBrand(brand) {
    const { cookies } = this.props;
    cookies.set('dev_brand', brand, { path: '/' });
    window.location.reload();
  }

  render() {
    const activeBrand = this.props.app.brand;
    return (
      <ButtonGroup>
        <Button
          size="sm"
          type={activeBrand === 'zillow' ? 'primary' : 'default'}
          onClick={() => this.updateBrand('zillow')}
        >
          Zillow
        </Button>
        <Button
          size="sm"
          type={activeBrand === 'hotpads' ? 'primary' : 'default'}
          onClick={() => this.updateBrand('hotpads')}
        >
          Hotpads
        </Button>
        <Button
          size="sm"
          type={activeBrand === 'trulia' ? 'primary' : 'default'}
          onClick={() => this.updateBrand('trulia')}
        >
          Trulia
        </Button>
      </ButtonGroup>
    );
  }
}

export default withCookies(connect(({ app }) => ({ app }))(BrandSwitcher));
